import { Footer } from "@bootstrap-styled/v4";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { colors, constants } from "utils";

export const OKOFooter = () => {
  const location = useLocation();

  const isEducatorLoginPath = location.pathname === constants.EDUCATOR_LOGIN_PATH

  return (
    <Container $isEducatorLogin={isEducatorLoginPath}>
      © {new Date().getFullYear()} Oko Labs, Inc. All rights reserved.
    </Container>
  );
};

const Container = styled(Footer)`
  position: fixed;
  text-align: center;
  padding: 1rem;
  font-size:  1rem;
  position: fixed;
  width: 100%;
  bottom: 0;
  color: ${colors.nightlyWoods500};

  ${({ $isEducatorLogin }) => {
    if ($isEducatorLogin) {
      return `
          color: #fff;
          font-size: 0.875rem;
        `
    }
  }}
`
